export const internalErrorCode = [
  'INVALID_CREDENTIALS',
  'AVAILABLE_PREMIUM_ID_NOT_ENOUGH',
  'MOVE_STUDENT_TO_PREMIUM_SEAT_FAILED_ALL',
  'MOVE_STUDENT_TO_PREMIUM_SEAT_FAILED_PARTIAL',
  'GET_AVAILABLE_PREMIUM_ID_FAILED',
  'GET_SCHOOL_FAILED',
  'SCHOOL_NOT_FOUND',
  'CLERK_UPDATE_ORGANIZATION_FAILED',
  'CLERK_AUTH_FAILED',
  'CLERK_USER_ID_NOT_FOUND',
  'CLERK_UPDATE_ORGANIZATION_LOGO_FAILED',
  'DB_UPDATE_SCHOOL_FAILED',
  'DB_UPDATE_ADDRESS_FAILED',
  'DB_CREATE_ADDRESS_FAILED',
  'DB_UPDATE_SCHOOL_FAILED',
  'DB_CREATE_ADDRESS_AND_UPDATE_SCHOOL_FAILED',
  'MAIN_USER_TO_SCHOOL_NOT_FOUND',
  'CANCEL_INVOICE',
  'CREATE_XENDIT_INVOICE_FAILED',
  'PRICE_NOT_FOUND',
  'ROLE_NOT_ALLOWED',
  'MINIMUM_SEATS_NOT_MET',
  'GET_OTP_FAILED',
  'VERIFY_OTP_FAILED',
  'EDIT_INVITATION_FAILED',
  'CREATE_MAIN_USER_TO_SCHOOL_FAILED',
  'CREATE_MAIN_USER_TO_FAMILY_FAILED',
  'CREATE_MAIN_USER_FAILED',
  'UPDATE_PROFILE_IMAGE_FAILED',
  'VOUCHER_NOT_FOUND',
  'VOUCHER_LIMIT_REACHED',
] as const

export type InternalErrorCode = (typeof internalErrorCode)[number] | (string & {})

export const errorMessages = (code: InternalErrorCode) => {
  switch (code) {
    case 'INVALID_CREDENTIALS':
      return { error: new Error('Email atau password yang Anda masukkan salah.'), shouldInvestigate: false }

    case 'AVAILABLE_PREMIUM_ID_NOT_ENOUGH':
      return {
        error: new Error('Kursi premium tidak cukup. Silahkan kurangi murid dari pilihan.'),
        shouldInvestigate: false,
      }

    case 'MOVE_STUDENT_TO_PREMIUM_SEAT_FAILED_ALL':
      return { error: new Error('Gagal memindahkan semua murid ke kursi premium.'), shouldInvestigate: true }

    case 'MOVE_STUDENT_TO_PREMIUM_SEAT_FAILED_PARTIAL':
      return { error: new Error('Gagal memindahkan beberapa murid ke kursi premium.'), shouldInvestigate: true }

    case 'GET_AVAILABLE_PREMIUM_ID_FAILED':
      return { error: new Error('Gagal mengambil data kursi premium.'), shouldInvestigate: false }

    case 'GET_SCHOOL_FAILED':
      return { error: new Error('Gagal mengambil data sekolah.'), shouldInvestigate: false }

    case 'SCHOOL_NOT_FOUND':
      return { error: new Error('Sekolah tidak ditemukan.'), shouldInvestigate: false }

    case 'CLERK_UPDATE_ORGANIZATION_FAILED':
      return { error: new Error('Gagal memperbarui data organisasi (auth).'), shouldInvestigate: false }

    case 'CLERK_AUTH_FAILED':
      return { error: new Error('Gagal mengautentikasi user (auth).'), shouldInvestigate: false }

    case 'CLERK_USER_ID_NOT_FOUND':
      return { error: new Error('User ID tidak ditemukan (auth).'), shouldInvestigate: false }

    case 'CLERK_UPDATE_ORGANIZATION_LOGO_FAILED':
      return { error: new Error('Gagal memperbarui logo organisasi (auth).'), shouldInvestigate: false }

    case 'DB_UPDATE_SCHOOL_FAILED':
      return { error: new Error('Gagal memperbarui data sekolah.'), shouldInvestigate: false }

    case 'DB_UPDATE_ADDRESS_FAILED':
      return { error: new Error('Gagal memperbarui data alamat.'), shouldInvestigate: false }

    case 'DB_CREATE_ADDRESS_FAILED':
      return { error: new Error('Gagal membuat data alamat.'), shouldInvestigate: false }

    case 'DB_CREATE_ADDRESS_AND_UPDATE_SCHOOL_FAILED':
      return { error: new Error('Gagal membuat data alamat dan memperbarui data sekolah.'), shouldInvestigate: false }

    case 'MAIN_USER_TO_SCHOOL_NOT_FOUND':
      return { error: new Error('Tidak dapat menemukan data keanggotaan sekolah user.'), shouldInvestigate: false }

    case 'CANCEL_INVOICE':
      return { error: new Error('Gagal membatalkan invoice yang sedang berlangsung.'), shouldInvestigate: false }

    case 'CREATE_XENDIT_INVOICE_FAILED':
      return { error: new Error('Gagal membuat invoice di Xendit.'), shouldInvestigate: false }

    case 'PRICE_NOT_FOUND':
      return { error: new Error('Harga tidak ditemukan.'), shouldInvestigate: false }

    case 'ROLE_NOT_ALLOWED':
      return { error: new Error('Kamu tidak memiliki akses ke halaman ini.'), shouldInvestigate: false }

    case 'MINIMUM_SEATS_NOT_MET':
      return { error: new Error('Kursi minimal tidak terpenuhi.'), shouldInvestigate: false }

    case 'GET_OTP_FAILED':
      return { error: new Error('Gagal mengirim kode OTP.'), shouldInvestigate: false }

    case 'VERIFY_OTP_FAILED':
      return { error: new Error('Gagal memverifikasi kode OTP. Silahkan kirim ulang OTP.'), shouldInvestigate: false }

    case 'EDIT_INVITATION_FAILED':
      return { error: new Error('Gagal mengedit data undangan.'), shouldInvestigate: false }

    case 'CREATE_MAIN_USER_TO_SCHOOL_FAILED':
      return { error: new Error('Gagal membuat data keanggotaan sekolah user.'), shouldInvestigate: false }

    case 'CREATE_MAIN_USER_TO_FAMILY_FAILED':
      return { error: new Error('Gagal membuat data keanggotaan keluarga user.'), shouldInvestigate: false }

    case 'CREATE_MAIN_USER_FAILED':
      return { error: new Error('Gagal membuat data user.'), shouldInvestigate: false }

    case 'UPDATE_PROFILE_IMAGE_FAILED':
      return { error: new Error('Gagal memperbarui gambar profil user.'), shouldInvestigate: false }

    case 'VOUCHER_NOT_FOUND':
      return { error: new Error('Voucher tidak ditemukan.'), shouldInvestigate: false }

    case 'VOUCHER_LIMIT_REACHED':
      return { error: new Error('Voucher sudah mencapai batas penggunaan.'), shouldInvestigate: false }

    default:
      return {
        error: new Error('Ada kesalahan yang terjadi saat melakukan aksi ini.'),
        shouldInvestigate: true,
      }
  }
}
